export default __webpack_public_path__ + "static/media/DOM-DEC2024.81e1fb87.png";